/* eslint no-unused-expressions: [0, { "allowShortCircuit": true }] */
export default function reduxPromiseRejectLogger() {
  return next => action => {
    if (action.error && typeof window !== 'undefined') {
      window.console && window.console.error(`Error for action ${action.type}`, action.payload, action.payload.stack);
    }

    return next(action);
  };
}



// WEBPACK FOOTER //
// ./src/util/redux-promise-reject-logger.js